import styled, { css, keyframes } from 'styled-components';

import { ASSET_PATH } from '../../assetsPath';
import { FlexDiv, GenericDiv } from 'commonStyles';

export const AppWrapper = styled.main`
padding-top: 80px;
.loadwrap {
	position: relative;
}

.custom-scroll {
	webkit-overflow-scrolling: touch;
	scrollbar-color:rgba(255, 255, 255, .5) rgba(0, 0, 0, .3);
	-ms-overflow-style : scrollbar;
	::-webkit-scrollbar {
			-webkit-appearance: none;
			width: 6px;
	}
	
	::-webkit-scrollbar-thumb {
			border-radius: 4px;
			background-color: rgba(0, 0, 0, .5);
			box-shadow: 0 0 1px rgba(255, 255, 255, .5);
	}
	::-webkit-scrollbar-track {
			background-color: rgba(0, 0, 0, .15)
	}
	::-webkit-scrollbar-thumb:hover {
			background: #555;
	}
}

`;
export const LandingSpriteIcon = styled.span`
    background:url(${ASSET_PATH.IMAGES}landing_NewSprite1.png) no-repeat;
    background-size: 400px 400px;
		display: inline-block;
    ${(props) => {
		switch (props.icon) {
			case 'icSpeaker':
				return css`
					background-position: -84px -12px;
					width: 48px;
					height: 48px;`;
			case 'icPlay':
				return css`
					background-position: 0 0;
					width: 78px;
					height: 78px;
					cursor: pointer;`;
			case 'icStar':
				return css`
					background-position: -142px -163px;
					min-width: 15px;
					height: 14px;`;
			case 'TM':
				return css`
					background-position: -22px -88px;
					width: 40px;
					height: 40px;`;
			case 'CB':
				return css`
					background-position: -87px -150px;
					width: 40px;
					height: 39px;`;
			case 'EM':
				return css`
					background-position: -88px -88px;
					width: 35px;
					height: 40px;`;
			case 'greenGift':
				return css`
					background-position: -362px -120px;
					width: 21px;
					height: 21px;`;
			case 'exclaim':
				return css`
					background-position: -83px -277px;
					width: 23px;
					height: 23px;`;
			case 'flight':
				return css`
					background-position:-280px -76px;
					width: 75px;
					height: 75px`;
			case 'hotel':
				return css`      
					background-position:-207px -71px;
					width: 75px;
					height: 75px;`;
			case 'cab':
				return css`      
					background-position: -9px -189px;
					width: 75px;
					height: 75px;`;
			case 'phone':
				return css`      
					background-position:-203px 4px;
					width: 75px;
					height: 75px;`;
			case 'icNote':
				return css`
					background-position: -31px -148px;
					width: 15px;
					height: 20px;`;
			case 'icBizCities':
				return css`
					background-position: -137px -312px;
					width: 22px;
					height: 22px;
		`;
			case 'icBlog':
				return css`
					background-position: -168px -311px;
					width: 22px;
					height: 22px;
		`;
			case 'icDownload':
				return css`
					background-position: -81px -312px;
					width: 22px;
					height: 22px;
		`;
			case 'icFollowUs':
				return css`
					background-position: -109px -312px;
					width: 22px;
					height: 22px;
		`;
			case 'icQuickLinks':
				return css`
					background-position: -232px -310px;
					width: 22px;
					height: 22px;
		`;
			case 'icLegals':
				return css`
					background-position: -200px -310px;
					width: 22px;
					height: 22px;
		`;
			case 'default':
				return css`
					width: 19px;
					height: 14px;
					background-position: -77px -8px;`;
			default:
				break;
		}
	}}
`;

export const HiddenElem = styled.div`
      height: 0;
      width: 0;
      overflow: ${(prop) => prop.activeModal ? 'visible' : 'hidden'};
`;

export const HeaderWrap = styled.div`
	.modal.myBiz {
		background: transparent;
	}
                           
`;

export const ChatIcon = styled.img(
	({ theme: { down, breakpoints } }) => `
		width: 72px;
		height: 72px;

`
);

export const ChatContainers = styled.div(
	({ theme: { down, breakpoints } }) => `
position: fixed;
right: 20px;
bottom: 50px;
overflow: hidden;
cursor: pointer;
z-index: 6;
>div, i{
	overflow: hidden;
	transition: opacity 500ms ease-in-out;
}
`
);
export const openAnim = keyframes`
	0% {width:72px;}
	100% {width:400px; height : 70%;}
`;

export const closeAninm = keyframes`
	0% {width:400px; height : 70%;}
	100% {width:72px;}
`;

export const ChatContainer = styled(FlexDiv)`
		width: 72px;
		height: 72px;
		padding: 0;
		border-radius: ${({ showBot }) => showBot ? '50px 50px 0px' : '50px'};
		box-shadow: 0 3px 22px 0 rgba(0, 0, 0, 0.1);
		border: solid 1px rgba(241, 117, 49, 0.3);
		background-color: #ffffff;
		position: fixed;
		right: 20px;
		bottom: 50px;
		overflow: hidden;
		cursor: pointer;
		z-index: 6;
		>div, i{
			overflow: hidden;
			transition: opacity 500ms ease-in-out;
		}
		i {
			opacity: 0;
		}
		// Only apply animations if user has interacted
		${({ showBot, hasInteracted }) =>
		hasInteracted ?
			showBot ?
				css`animation: ${openAnim} 0.5s ease-in-out forwards ;` :
				css`animation: ${closeAninm} 0.5s ease-in-out forwards ;` :
			showBot ?
				css`width: 608px; height: 70%;` : // Instant expand without animation
				css`width: 72px; height: 72px;` // Instant collapse without animation
}
`;

export const HelloMessage = styled(GenericDiv)`
text-align: left;
`;

export const CloseWrapper = styled.span`
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 50%;
	transition: background 0.2s ease;

	&:hover {
		background: #f5f5f5;
	}
`;
